import {registrationVoucher} from "../../../network/Endpoint";
import ButtonImg from "../../classStudentManagement/components/ButtonImg";
import RegistrationBtn from "../../../assets/images/classes/registration_btn.png";
import React, {useState} from "react";
import {messageToast} from "../../../components/Toast";
import InfoIco from "../../../assets/images/classes/info.png"

const RegistrationVoucherPage = ({teacherId, fetchActiveLicenses, fetchLicensesYearList}) => {
    const [voucherCode, setVoucherCode] = useState("");

    const fetchRegistrationVoucher = async () => {
        let trimmedCode = voucherCode.trim().toUpperCase(); // 공백 제거 및 대문자 변환

        if (!trimmedCode) {
            alert("이용권 번호를 입력해주세요.");
            return;
        }

        if (trimmedCode.startsWith('P')) {
            alert("등록하신 이용권은\n네이버에서 구매하신 이용권입니다.\n\n해당 이용권은 개인 이용권으로 LMS에서는 등록이 불가능합니다.\n\n받으신 메시지에 첨부된 이용권 등록방법 링크를\n참고하셔서 이용권을 등록해 주시기 바랍니다.");
            return;
        }

        try{
            const body = {
                teacherId: teacherId,
                voucherCode: trimmedCode
            };
            const res = await registrationVoucher(body);

            const statusCode = res.data.status.code;
            if(statusCode === 'Success') {
                messageToast({message:"이용권이 등록되었습니다.",description:"이용권 적용 메뉴에서 확인해 주세요."});
                setVoucherCode("");     // 입력 초기화
                fetchActiveLicenses();
                fetchLicensesYearList();
            } else {
                alert(`[${statusCode}] 등록 실패: ${res.data.status.message}`);
            }
        }catch (error){
            alert('오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    }


    return (
        <>
            <div className="my-8 text-xl font-medium text-center text-zinc-600 max-md:max-w-full">
                등록할 이용권의 번호를 넣고, 등록 버튼을 눌러주세요.
            </div>

            <div
                className="flex justify-center items-center gap-8 w-full min-h-[112px] bg-white mb-[52px] max-w-[1044px] px-8 py-[27px] rounded-[20px] border-[0.5px] border-[#DADADA] border-solid shadow-custom">
                <div
                    className="flex justify-center items-center align-middle text-[#50555F] text-center text-2xl font-[700]">
                    이용권 등록
                </div>
                <input
                    type="text"
                    value={voucherCode}
                    onChange={(e) => setVoucherCode(e.target.value)} // 포커스 아웃 시 중복 체크
                    placeholder="문자 메시지로 발송된 이용권 번호를 입력해주세요."
                    className="border-[2px] rounded-[10px] border-[#557CFC] max-w-full text-left w-[637px] h-[48px] px-3 py-[13px] text-xl font-[500] text-[#50555F]"
                />
                <div
                    className="flex justify-center items-center align-middle text-[#50555F] text-center text-2xl font-[700]">
                    <ButtonImg
                        image={RegistrationBtn}
                        label="이용권 등록 하기"
                        onClick={fetchRegistrationVoucher}
                    />
                </div>
            </div>

            <div className="flex max-w-[1044px] w-full p-8 flex-col justify-start items-start gap-5 bg-[#EDF3FF] border-[1px] border-[#DCE8FF] shadow-custom rounded-[20px] ">
                <div className="inline-flex items-center px-[6px] py-2 gap-5">
                    <img
                        src={InfoIco}
                        alt="info Icon"
                        className="flex w-8 h-8 justify-center items-center"
                    />
                    <div className="text-[#50555F] text-[28px] font-[700] leading-none">
                        이용권 등록 시, 유의사항 안내
                    </div>
                </div>
                <div className="inline-flex flex-col justify-center gap-[18px] ml-3">
                    <div className="flex h-6 justify-start items-center gap-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <circle cx="4" cy="4" r="4" fill="#979797"/>
                        </svg>
                        <div className="text-[#91959D] text-xl font-[500] leading-none">
                            이용권 등록 시점부터 이용 기간이 시작됩니다. 실제 사용하시려는 기간에 맞춰 등록해주세요.
                        </div>
                    </div>
                    <div className="flex h-6 justify-start items-center gap-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <circle cx="4" cy="4" r="4" fill="#979797"/>
                        </svg>
                        <div className="text-[#91959D] text-xl font-[500] leading-none">
                            이용권 구매 후 14일 이내로 환불이 가능합니다.
                        </div>
                    </div>
                    <div className="flex h-6 justify-start items-center gap-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <circle cx="4" cy="4" r="4" fill="#979797"/>
                        </svg>
                        <div className="text-[#91959D] text-xl font-[500] leading-none">
                            해당 등록 내역은 [이용권 내역]에서 확인 가능합니다.
                        </div>
                    </div>
                    <div className="flex h-6 justify-start items-center gap-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <circle cx="4" cy="4" r="4" fill="#979797"/>
                        </svg>
                        <div className="text-[#91959D] text-xl font-[500] leading-none">
                            14일 이후 이용권 환불은 정상가 기준으로 환불됩니다.
                        </div>
                    </div>
                    <div className="flex h-6 justify-start items-center gap-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <circle cx="4" cy="4" r="4" fill="#979797"/>
                        </svg>
                        <div className="text-[#91959D] text-xl font-[500] leading-none">
                            이용권 되팔기로 인한 모든 분쟁 요소는 책임지지 않습니다.
                        </div>
                    </div>
                    <div className="flex h-6 justify-start items-center gap-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <circle cx="4" cy="4" r="4" fill="#979797"/>
                        </svg>
                        <div className="text-[#91959D] text-xl font-[500] leading-none">
                            문의사항은 <b>고객센터(1544-6020)</b>으로 연락 주시기 바랍니다.
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RegistrationVoucherPage;